import { FormContext } from '../formManager/formContext';
import { TextInput } from '@interstate/components/TextInput';
import { useContext, useState } from 'react';
import type { FormTextInputProps } from '../types';
import { isBlurEvent } from '@makemydeal/dr-shared-ui-utils';
import { dealLockHooks } from '../../hooks';

export const FormTextInput = ({ name, label, inputSuffix, masking, sx, maxLength, maxLengthErrorMessage }: FormTextInputProps) => {
    const context = useContext(FormContext);
    const refresh = useState(0)[1];
    const isLocked = dealLockHooks.useIsDealLocked();

    return (
        <TextInput
            value={context.form.values[name] as string}
            data-testid={'vehicle-input-' + name}
            label={label}
            id={name}
            key={name}
            name={name}
            inputSuffix={inputSuffix}
            hasError={Boolean(context.form.error[name])}
            errorMessage={context.form.error[name]}
            onChange={(ev) => {
                if (isBlurEvent(ev)) {
                    return;
                }
                context.changeHandler(name, ev.target.value as string);
                refresh(Date.now());
            }}
            onBlur={() => {
                context.handleBlur(name, context.form.values[name] as string);
                refresh(Date.now());
            }}
            masking={masking}
            {...(maxLength && {
                maxLength,
                // The library default quotes the whole entered value back, which overflows the drawer
                customErrorMessages: { exceedsMaxLength: maxLengthErrorMessage }
            })}
            sx={sx}
            disabled={isLocked}
        />
    );
};
